module.exports = __webpack_public_path__ + "static/media/Riviera_Level_26.5326ac03.jpg";